import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { ColorRing } from 'react-loader-spinner';
import QuestionsContainer from '../../common/QuestionsContainer';
import ProfileSuggestionModal from '../../ProfileSuggestionModal';
var renderSpinner = function renderSpinner() {
  return /*#__PURE__*/React.createElement(ColorRing, {
    visible: true,
    height: "20",
    width: "20",
    ariaLabel: "blocks-loading",
    wrapperStyle: {},
    wrapperClass: "updating-icon me-2",
    colors: Array(5).fill('#FFFFFF')
  });
};
var EditUser = /*#__PURE__*/function (_Component) {
  function EditUser(props) {
    var _this;
    _classCallCheck(this, EditUser);
    _this = _callSuper(this, EditUser, [props]);
    _this.state = {
      isHovering: false,
      showModal: false,
      confirmationSent: false,
      answers: props.answers,
      saveDisabled: false
    };
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleAppendTags = _this.handleAppendTags.bind(_this);
    _this.handleClearSuggestions = _this.handleClearSuggestions.bind(_this);
    _this.handleToggleSave = _this.handleToggleSave.bind(_this);
    return _this;
  }
  _inherits(EditUser, _Component);
  return _createClass(EditUser, [{
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var showModal = this.state.showModal;
      if (!showModal) {
        this.setState({
          isHovering: false
        });
      }
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      var _this2 = this;
      var _this$props = this.props,
        getAnswers = _this$props.getAnswers,
        updateCompletionPercentage = _this$props.updateCompletionPercentage;
      getAnswers().then(function (response) {
        updateCompletionPercentage();
        _this2.setState({
          answers: response.data,
          showModal: false,
          isHovering: false
        });
      });
    }
  }, {
    key: "handleAppendTags",
    value: function handleAppendTags() {
      var _this3 = this;
      var _this$props2 = this.props,
        updateSuggestedTags = _this$props2.updateSuggestedTags,
        getAnswers = _this$props2.getAnswers,
        updateCompletionPercentage = _this$props2.updateCompletionPercentage;
      updateSuggestedTags([], 'Level');
      getAnswers().then(function (response) {
        updateCompletionPercentage();
        _this3.setState({
          answers: response.data,
          showModal: false,
          isHovering: false
        });
      });
    }
  }, {
    key: "handleClearSuggestions",
    value: function handleClearSuggestions(tagIds) {
      var _this$props3 = this.props,
        updateSuggestedTags = _this$props3.updateSuggestedTags,
        suggestedTags = _this$props3.suggestedTags;
      updateSuggestedTags(suggestedTags.Level.filter(function (tag) {
        return !tagIds.includes(tag.id);
      }), 'Level');
    }
  }, {
    key: "handleToggleSave",
    value: function handleToggleSave(saveDisabled) {
      this.setState({
        saveDisabled: saveDisabled
      });
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      var _this4 = this;
      var editMode = this.props.editMode;
      var isHovering = this.state.isHovering;
      if (isHovering || editMode) {
        return /*#__PURE__*/React.createElement("a", {
          className: "edit-attribute medium-weight body-text-2",
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this4.handleShowModal();
          }
        }, "Edit");
      }
      return null;
    }
  }, {
    key: "renderAdd",
    value: function renderAdd(attribute, text) {
      var _this5 = this;
      return /*#__PURE__*/React.createElement("span", {
        className: "add-answer ".concat(attribute, " body-text-3 me-3")
      }, /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        onClick: function onClick() {
          return _this5.handleShowModal();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus"
      }), "Add ".concat(text)), attribute === 'seniorities' && this.renderSenioritySuggestions());
    }
  }, {
    key: "renderField",
    value: function renderField(attribute, icon, answer) {
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(attribute, " body-text-2 me-3")
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa ".concat(icon, " me-2")
      }), answer, attribute === 'seniorities' && this.renderSenioritySuggestions());
    }
  }, {
    key: "renderSenioritySuggestions",
    value: function renderSenioritySuggestions() {
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        suggestedTags = _this$props4.suggestedTags,
        showSuggestionModal = _this$props4.showSuggestionModal;
      if (!suggestedTags.Level || suggestedTags.Level.length === 0) return null;
      return /*#__PURE__*/React.createElement(ProfileSuggestionModal, {
        tags: suggestedTags.Level,
        csrfToken: csrfToken,
        appendTags: this.handleAppendTags,
        clearTags: this.handleClearSuggestions,
        showEdit: false,
        forceShow: showSuggestionModal === 'Level'
      });
    }
  }, {
    key: "renderAttribute",
    value: function renderAttribute(attribute, icon, answer, addText) {
      if (answer) {
        return this.renderField(attribute, icon, answer);
      }
      return this.renderAdd(attribute, addText);
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this$props5 = this.props,
        questionnaireQuestions = _this$props5.questionnaireQuestions,
        questionableId = _this$props5.questionableId,
        questionableType = _this$props5.questionableType,
        questionnaireName = _this$props5.questionnaireName,
        csrfToken = _this$props5.csrfToken,
        userId = _this$props5.userId;
      return /*#__PURE__*/React.createElement("div", {
        className: "work-preferences-form"
      }, /*#__PURE__*/React.createElement(QuestionsContainer, {
        questionnaireName: questionnaireName,
        questionIds: questionnaireQuestions,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        handleToggleSave: this.handleToggleSave,
        userId: userId,
        owner: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        showModal = _this$state.showModal,
        answers = _this$state.answers,
        saveDisabled = _this$state.saveDisabled;
      var location = answers.find(function (a) {
        return a.question_key === 'Location';
      }).answer;
      var seniorities = answers.find(function (a) {
        return a.question_key === 'Role Level';
      }).answer.map(function (a) {
        return a.label;
      });
      var yearsOfExperience = answers.find(function (a) {
        return a.question_key === 'Years Of Experience';
      }).answer;
      return /*#__PURE__*/React.createElement("div", {
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/React.createElement("div", {
        className: "level-yrs-location pt-2"
      }, this.renderAttribute('years-of-experience', 'fa-id-card-alt', yearsOfExperience && "".concat(yearsOfExperience, " year").concat(yearsOfExperience === 0 || yearsOfExperience > 1 ? 's' : '', " of experience"), 'Years of Experience'), this.renderAttribute('seniorities', 'fa-certificate', seniorities.join(', '), 'Seniority'), this.renderAttribute('location', 'fa-map-marker-alt', location, 'Location'), this.renderEdit()), /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom"
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "style-guide"
      }, this.renderForm()), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        variant: "primary",
        onClick: this.handleCloseModal,
        disabled: saveDisabled,
        className: "save-button ".concat(saveDisabled ? 'with-spinner' : '')
      }, saveDisabled && renderSpinner(), "Save"))));
    }
  }]);
}(Component);
EditUser.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool.isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getAnswers: PropTypes.func.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  updateCompletionPercentage: PropTypes.func.isRequired,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
  userId: PropTypes.number.isRequired
};
EditUser.defaultProps = {
  showSuggestionModal: '',
  suggestedTags: {},
  updateSuggestedTags: function updateSuggestedTags() {}
};
export default EditUser;